import React from "react";
import IconRoundButton from "../CommonButtons/IconRoundButton";
import CommonBankLogo from "../CommonBankLogo";
import TickerAnimation from "../TickerAnimation";
import "./index.css";
import FormatAmount from "../FormatAmount/FormatAmount";

const PrivateTxnEntry = ({
  column1Title,
  column1Subtitle = "Column1 subtitle",
  onColumn1Click,

  column2Title,
  column2Subtitle = "Column2 subtitle",
  ifsc,

  column3Title,
  column3Subtitle = "Column3 subtitle",
  showCurrencySymbol,

  button1 = null,
  button2 = null,

  showActions = false,

  visualStatus, //only needed and used for private txn validate flow
  transitionStatus, //only needed and used for private txn validate flow
  isSlidingIn, //only needed and used for private txn validate flow
  isAnimating, //only needed and used for private txn validate flow
}) => {
  const effectiveStatus =
    visualStatus === "reject" ? "1" : visualStatus === "approve" ? "2" : null;
  const effectiveTransitionStatus =
    transitionStatus === "reject"
      ? "1"
      : transitionStatus === "approve"
        ? "2"
        : null;
  const sliding = isSlidingIn;

  const handleBtn1Click = () => {
    if (button1?.isDisabled) return;
    button1?.onClick();
  };

  const handleBtn2Click = () => {
    if (button2?.isDisabled) return;
    button2?.onClick();
  };

  const statusBgClass =
    effectiveStatus === "1"
      ? button1?.bgClass
      : effectiveStatus === "2"
        ? button2?.bgClass
        : "";

  const transitionBgClass =
    effectiveTransitionStatus === "1"
      ? button1?.bgClass
      : effectiveTransitionStatus === "2"
        ? button2?.bgClass
        : "";

  const isBtn1Disabled = button1?.isDisabled || effectiveStatus === "1";
  const isBtn2Disabled = button2?.isDisabled || effectiveStatus === "2";

  return (
    <div
      className="
        beneTxnRequiredValidatetion_card 
        w-max-content-width max-w-full 
        relative overflow-hidden 
        rounded-border-radius-md 
        py-padding-sm px-padding-md
      "
    >
      <div
        className={`
          absolute inset-top-base bg-primary-card 
          transition-opacity duration-animation-fast
          ${effectiveStatus ? "opacity-opacity-none" : "opacity-base-opacity"}
        `}
        style={{ zIndex: "var(--z-index-content)" }}
      />

      {effectiveTransitionStatus && (
        <div
          className={`
            absolute inset-top-base h-full
            ${transitionBgClass}
            transition-[transform,opacity] duration-animation-fast ease-in-out
          `}
          style={{
            transform: sliding ? "translateX(0)" : "translateX(100%)",
            opacity: "var(--light-opacity)",
            zIndex: "var(--z-index-header)",
          }}
        />
      )}

      {effectiveStatus && !effectiveTransitionStatus && (
        <div
          className={`
            absolute inset-top-base h-full
            ${statusBgClass}
          `}
          style={{
            opacity: "var(--light-opacity)",
            zIndex: "var(--z-index-header)",
          }}
        />
      )}

      <div className="relative z-z-index-max flex items-start Qlg:gap-gap-base gap-gap-md Qlg:items-center Qlg:flex-row flex-col-reverse">
        <div className="Qlg:w-column-width-lg w-width-full justify-between flex flex-row Qlg:flex-col Qlg:justify-center ">
          <div className="Qlg:w-width-full w-width-md">
            <span
              className="ticker-force-underline text-font-sm text-pending cursor-pointer truncate max-w-full"
              onClick={onColumn1Click}
            >
              <TickerAnimation
                text={column1Title}
                className="ticker-underline"
              />
            </span>

            <p className="text-font-xs text-text-secondary mt-margin-xs">
              {column1Subtitle}
            </p>
          </div>

          {showActions && (
            <div className="flex items-center gap-gap-md Qlg:hidden">
              {button1 && (
                <IconRoundButton
                  handleFunction={handleBtn1Click}
                  enabledBgColor={button1.enabledBgColor}
                  icon={button1.icon}
                  title={!isBtn1Disabled ? button1.tooltip : ""}
                  isDisabled={isBtn1Disabled}
                  type="privateTxn"
                  iconSize="var(--icon-sm)"
                />
              )}

              {button2 && (
                <IconRoundButton
                  handleFunction={handleBtn2Click}
                  enabledBgColor={button2.enabledBgColor}
                  icon={button2.icon}
                  title={!isBtn2Disabled ? button2.tooltip : ""}
                  imgColor="var(--text-primary)"
                  isDisabled={isBtn2Disabled}
                  type="privateTxn"
                  iconSize="var(--icon-sm)"
                />
              )}
            </div>
          )}
        </div>

        {/* <div className="h-category-icon-height Qlg:block hidden w-px bg-primary-bg mx-margin-md" /> */}

        <div className="flex items-center w-width-full Qlg:w-auto justify-between Qlg:border-r-border Qlg:border-l-border Qlg:border-primary-bg Qlg:px-padding-md Qlg:mx-margin-md">
          <div className="Qsm:w-column-width-md w-width-md flex flex-col justify-center">
            <span className="text-font-sm text-text-primary font-medium truncate">
              <TickerAnimation text={column2Title} />
            </span>
            <p className="text-font-xs text-text-secondary mt-margin-xs">
              {column2Subtitle}
            </p>
          </div>

          <div className="ml-margin-md">
            <CommonBankLogo
              ifsc={ifsc}
              variant="big"
              type="pill"
            />
          </div>
        </div>

        {/* <div className="h-category-icon-height w-px bg-primary-bg mx-margin-md Qlg:block hidden" /> */}

        <div className="w-column-width-md flex flex-col justify-center">
          <span className="text-font-sm text-settled font-semibold">
            {(() => {
              const formattedAmount = FormatAmount({ price: column3Title });
              const shouldShowCurrency =
                showCurrencySymbol ??
                (typeof column3Title === "string" &&
                  column3Title.includes("INR"));

              if (
                shouldShowCurrency &&
                formattedAmount &&
                formattedAmount !== "Redacted"
              ) {
                return `INR ${formattedAmount}`;
              }

              return formattedAmount;
            })()}
          </span>
          <p className="text-font-xs text-text-secondary mt-margin-xs">
            {column3Subtitle}
          </p>
        </div>

        {showActions && (
          <>
            {/* <div className="h-category-icon-height w-px bg-primary-bg mx-margin-md Qlg:block hidden" /> */}
            <div className="Qlg:flex hidden items-center gap-gap-sm Qlg:gap-gap-md ml-margin-sm border-l-border border-primary-bg pl-padding-md">
              {button1 && (
                <IconRoundButton
                  handleFunction={handleBtn1Click}
                  enabledBgColor={button1.enabledBgColor}
                  icon={button1.icon}
                  title={!isBtn1Disabled ? button1.tooltip : ""}
                  isDisabled={isBtn1Disabled}
                  type="privateTxn"
                  iconSize="var(--icon-sm)"
                />
              )}

              {button2 && (
                <IconRoundButton
                  handleFunction={handleBtn2Click}
                  enabledBgColor={button2.enabledBgColor}
                  icon={button2.icon}
                  title={!isBtn2Disabled ? button2.tooltip : ""}
                  imgColor="var(--text-primary)"
                  isDisabled={isBtn2Disabled}
                  type="privateTxn"
                  iconSize="var(--icon-sm)"
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PrivateTxnEntry;
